import styled from '@emotion/styled';
import { AvatarWithText, colors, Stack, Typography } from '@ui-components/neo.tax';
import { ReactComponent as NeoTaxWordmark } from '@ui-components/neo.tax/dist/images/wordmark.svg';

import { NAV_HEIGHT } from '@neo.tax/shared/constants';
import { ZIndex } from '@neo.tax/shared/utils';

export const NavContainer = styled.nav({
  height: NAV_HEIGHT,
});

export const NavInnerContainer = styled(Stack)<{ $superUserMode?: boolean }>(
  {
    height: NAV_HEIGHT,
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    zIndex: ZIndex.TOP_NAV,
    padding: '0 1.5rem 0 1rem',
  },
  ({ $superUserMode }) => ($superUserMode ? { background: colors.blue[200] } : { background: colors.white }),
);

export const SuperUserModeText = styled(Typography)({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  right: 180,
  textTransform: 'uppercase',
  color: colors.rsbry[500],
});

export const StyledAvatarWithText = styled(AvatarWithText)({
  minWidth: '96px',
});

export const NavColumnContainer = styled(Stack)({
  flexGrow: 1,
});

export const CompanyNameContainer = styled(NavColumnContainer)({
  overflow: 'hidden',
  padding: '0 4rem',
  textAlign: 'left',
});

export const StyledWordmark = styled(NeoTaxWordmark)({
  color: colors.primary[600],
});

export const PeriodPickerContainer = styled(Stack)({
  whiteSpace: 'nowrap',
});

export const VerticalDivider = styled.div({
  borderLeft: `1px solid ${colors.gray[400]}`,
  height: '40px',
  margin: '0 1rem',
});

export const OrganizationLogo = styled.img({
  maxHeight: '32px',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
});
